module.exports = __webpack_public_path__ + "static/media/WT.f605454d.svg";